// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I5nq","toggleWrap":"styles_toggleWrap__3bkTE","content":"styles_content__t29Xf","selectAreaCode":"styles_selectAreaCode__A_y5e"};